module.exports = __webpack_public_path__ + "img/corsair-19.039fac07.png";